import { Animate } from 'components/lib';
import { UserOrganizationSwitch } from 'components/user/UserOrganizationSwitch';
import { AccountIcon } from 'components/icons';
import { useNavigate } from 'react-router-dom';

export function SignupPlanReadonly() {
  const navigate = useNavigate();

  return (
    <Animate>
      <div className="plan-readonly-shell">
        <div className="plan-readonly-panel">
          <div className="plan-readonly-panel__topbar">
            <div className="signup-plan-page-topbar__leading">
              <button
                className="signup-plan-page-logout signup-plan-page-logout--left"
                type="button"
                onClick={() => navigate('/account')}
                title="Manage account"
                aria-label="Manage account"
              >
                <AccountIcon style={{ width: 18, height: 18 }} />
                <span>Manage account</span>
              </button>
            </div>
            <div className="plan-readonly-panel__topbar-actions">
              <UserOrganizationSwitch
                className="signup-plan-page-user-switch user-switch-bar"
                nameClassName="signup-plan-page-user-switch__text"
                separatorClassName="signup-plan-page-user-switch__separator"
                switchButtonClassName="user-switch-trigger signup-plan-page-user-switch__trigger"
              />
            </div>
          </div>

          <div className="plan-readonly-panel__body">
            <div className="plan-readonly-panel__icon" aria-hidden="true">
              i
            </div>
            <div className="plan-readonly-panel__content">
              <p className="plan-readonly-panel__text">
                Please contact your organization owner to subscribe to a plan and activate access for your team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Animate>
  );
}
